import { render } from "./UserPasswordReset.vue?vue&type=template&id=265b1fa5&scoped=true"
import script from "./UserPasswordReset.vue?vue&type=script&lang=js"
export * from "./UserPasswordReset.vue?vue&type=script&lang=js"

import "./UserPasswordReset.vue?vue&type=style&index=0&id=265b1fa5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265b1fa5"]])

export default __exports__